import { Carousel } from "@fancyapps/ui";
import { Autoplay } from "@fancyapps/ui/dist/carousel/carousel.autoplay.esm.js";
import "@fancyapps/ui/dist/carousel/carousel.autoplay.css";

const partnersContainer = document.querySelectorAll(
	".wp-block-c-block-partners",
);
if (partnersContainer.length) {
	partnersContainer.forEach((partners) => {
		const partner = partners.querySelector(".partners");
		new Carousel(
			partner,
			{
				Dots: false,
				Navigation: false,
				infinite: true,
				initialSlide: 1,
				slidesPerPage: 1,
				center: true,
				Autoplay: {
					timeout: 3000,
					pauseOnHover: false,
					showProgress: false,
				},
				breakpoints: {
					"(min-width: 1023px)": {
						enabled: false,
					},
				},
			},
			{ Autoplay },
		);
	});
}
